import React, { useState, useEffect } from "react";
import config from "../../config";
import {
  TextField,
  Button,
  Typography,
  Box,
  Container,
  Paper,
  Grid,
  IconButton,
  Autocomplete,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ratings = [1, 2, 3, 4, 5];
const company = JSON.parse(sessionStorage.getItem("companyDetails"));
const currencies = [
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
];

export default function AddHotel() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    location: "",
    city: "",
    cityCode: "",
    mobile: "",
    email: "",
    pincode: "",
    rating: "",
    mapLocation: "",
    address: "",
    description: "",
    restaurants: "",
    attractions: [""],
    amenities: [""],
    images: [],
    floorCount: "",
    rooms: [],
    hotelLogo: null,
    currency: "INR",
    checkInTime: "",
    checkOutTime: "",
    is24Hour: false,          
    gstNumber: "",   
    ReceptionNo:"",
   foodLicenseNumber: "",  
  });

  const [cities, setCities] = useState([]);

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (!user) navigate("/");

    const fetchCities = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(`${config.API_BASE_URL}/Home/GetAllCity`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error("Failed to load cities");
        const data = await response.json();
        setCities(data);
      } catch (err) {
        console.error(err);
        toast.error("Error loading cities");
      }
    };
    fetchCities();
  }, [navigate]);

  const validate = () => {
  console.log("Form Data:", form);

  if (!form.name.trim()) { toast.error("Hotel Name is required"); return false; }
  if (!form.location.trim()) { toast.error("State is required"); return false; }
  if (!form.mobile.trim()) { toast.error("Mobile is required"); return false; }
  if (!form.pincode.trim()) { toast.error("Pincode is required"); return false; }
  if (!form.mapLocation.trim()) { toast.error("Map URL is required"); return false; }
  if (!form.address.trim()) { toast.error("Address is required"); return false; }
  if (!form.description.trim()) { toast.error("Description is required"); return false; }
  if (!form.city.trim()) { toast.error("City is required"); return false; }
  if (!form.rating) { toast.error("Rating is required"); return false; }
  if (!form.floorCount) { toast.error("Floor count is required"); return false; }

  if (form.rooms.length === 0 || form.rooms.some((r) => !r || r <= 0)) {
    toast.error("Please enter room count for all floors");
    return false;
  }

  if (form.amenities.length === 0 || form.amenities.every((a) => !a.trim())) {
    toast.error("At least one Amenity is required");
    return false;
  }

  if (form.attractions.length === 0 || form.attractions.every((a) => !a.trim())) {
    toast.error("At least one Attraction is required");
    return false;
  }

  if (form.images.length === 0) {
    toast.error("At least one image is required");
    return false;
  }

  if (!form.hotelLogo) {
    toast.error("Hotel Logo is required");
    return false;
  }

  if (!form.currency) {
    toast.error("Currency is required");
    return false;
  }

  return true;
};
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleArrayChange = (field, index, value) => {
    const updated = [...form[field]];
    updated[index] = value;
    setForm({ ...form, [field]: updated });
  };

  const addArrayField = (field) =>
    setForm({ ...form, [field]: [...form[field], ""] });

  const removeArrayField = (field, index) => {
    const updated = [...form[field]];
    updated.splice(index, 1);
    setForm({ ...form, [field]: updated });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({ file }));
    setForm((prev) => ({ ...prev, images: [...prev.images, ...newImages] }));
  };

  const handleDeleteImage = (index) => {
    setForm((prev) => {
      const copy = [...prev.images];
      copy.splice(index, 1);
      return { ...prev, images: copy };
    });
  };

  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();
    if (!validate()) return;

    try {
      const formData = new FormData();
      formData.append("Name", form.name);
      formData.append("Location", form.location);
      formData.append("Rating", form.rating.toString());
      formData.append("Address", form.address);
      formData.append("City", form.city);
      formData.append("CityCode", form.cityCode);
      formData.append("Mobile", form.mobile);
      formData.append("Pincode", form.pincode);
      formData.append("MapLocation", form.mapLocation);
      formData.append("Description", form.description);
      formData.append("FloorCount", parseInt(form.floorCount));
      formData.append("Currency", form.currency);
      formData.append("Email", form.email);
 if (!form.is24Hour) {
  if (form.checkInTime) {
    formData.append("CheckInTime", form.checkInTime);
  }

  if (form.checkOutTime) {
    formData.append("CheckOutTime", form.checkOutTime);
  }
}
      formData.append("Is24Hour", form.is24Hour ? "true" : "false");  
      formData.append("Restaurants", form.restaurants ?? "");
   formData.append("Riceptionno", form.ReceptionNo ?? "");
      formData.append("CompanyId", company?.id ?? "");
if (form.gstNumber?.trim()) {
  formData.append("GstNumber", form.gstNumber.trim());
}

if (form.foodLicenseNumber?.trim()) {
  formData.append("FoodLicenseNumber", form.foodLicenseNumber.trim());
}

      if (form.hotelLogo) formData.append("HotelLogo", form.hotelLogo);

      // Rooms
      form.rooms.forEach((r) => {
        if (r) formData.append("Rooms", parseInt(r));
      });

      // Email validation (still kept because it was here before)
      if (!form.email?.trim()) return toast.error("Email is required"), false;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
        return toast.error("Invalid email format"), false;

      // Arrays
      form.amenities.forEach((a) => a.trim() && formData.append("Amenities", a.trim()));
      form.attractions.forEach((a) => a.trim() && formData.append("Attractions", a.trim()));
      form.images.forEach((img) => img.file && formData.append("Images", img.file));

      const token = sessionStorage.getItem("token");
      const response = await fetch(`${config.API_BASE_URL}/Home/SaveHotel`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        toast.error("Error: " + (errorData.message || response.statusText));
        return;
      }

      toast.success("Hotel saved successfully!");
      setForm({
        name: "",
        location: "",
        city: "",
        cityCode: "",
        mobile: "",
        pincode: "",
        rating: "",
        mapLocation: "",
        address: "",
        description: "",
        attractions: [""],
        amenities: [""],
        images: [],
        floorCount: "",
        rooms: [],
        hotelLogo: null,
        currency: "INR",
        checkInTime: "",
        checkOutTime: "",
        is24Hour: false,
        gstNumber: "",
        foodLicenseNumber: "",
      });
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while saving the hotel.");
    }
  };

  const smallTextStyle = { height: "45px" };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
      <ToastContainer position="top-center" autoClose={3000} />
      <form onSubmit={handleSubmit}>
        {/* Hotel Details */}
        <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" mb={2} fontWeight="bold">
            Hotel Details
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField label="Hotel Name" name="name" value={form.name} onChange={handleChange} fullWidth size="small" sx={smallTextStyle} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="State" name="location" value={form.location} onChange={handleChange} fullWidth size="small" sx={smallTextStyle} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="Mobile" name="mobile" value={form.mobile} onChange={handleChange} fullWidth size="small" sx={smallTextStyle} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
  label="Reception No"
  name="ReceptionNo"
  value={form.ReceptionNo}
  onChange={handleChange}
  fullWidth
  size="small"
  sx={smallTextStyle}
/>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Restaurant DbName"
                name="restaurants"
                value={form.restaurants}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={smallTextStyle}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Email"
                name="email"
                value={form.email || ""}
                onChange={handleChange}
                type="email"
                placeholder="example@hotel.com"
                fullWidth
                size="small"
                sx={smallTextStyle}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="Pincode" name="pincode" value={form.pincode} onChange={handleChange} fullWidth size="small" sx={smallTextStyle} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="Map URL" name="mapLocation" value={form.mapLocation} onChange={handleChange} fullWidth size="small" sx={smallTextStyle} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="Address" name="address" value={form.address} onChange={handleChange} fullWidth size="small" sx={smallTextStyle} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Description" name="description" value={form.description} onChange={handleChange} fullWidth size="small" sx={smallTextStyle} />
            </Grid>
          </Grid>
        </Paper>

        {/* Hotel Logo Upload */}
        <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" mb={2} fontWeight="bold">Hotel Logo</Typography>
          <Button variant="contained" component="label" startIcon={<PhotoCamera />}>
            Upload Logo (Square Recommended)
            <input
              hidden
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) setForm(prev => ({ ...prev, hotelLogo: file }));
              }}
            />
          </Button>

          {form.hotelLogo && (
            <Box sx={{ mt: 2, textAlign: "center" }}>
              <Box sx={{ position: "relative", display: "inline-block", width: 160, height: 160, border: "2px dashed #ccc", borderRadius: 3, overflow: "hidden" }}>
                <img
                  src={URL.createObjectURL(form.hotelLogo)}
                  alt="Hotel Logo"
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                  onLoad={(e) => URL.revokeObjectURL(e.target.src)}
                />
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => setForm(prev => ({ ...prev, hotelLogo: null }))}
                  sx={{ position: "absolute", top: 4, right: 4, bgcolor: "rgba(255,255,255,0.9)" }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
              <Typography variant="body2" color="text.secondary" mt={1}>
                {form.hotelLogo.name}
              </Typography>
            </Box>
          )}
        </Paper>

        {/* Currency Selection */}
        <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" mb={2} fontWeight="bold">Currency</Typography>
          <Autocomplete
            options={currencies}
            getOptionLabel={(opt) => `${opt.name} (${opt.code}) - ${opt.symbol}`}
            value={currencies.find(c => c.code === form.currency) || currencies[0]}
            onChange={(_, newVal) => setForm(prev => ({ ...prev, currency: newVal?.code || "INR" }))}
            renderInput={(params) => <TextField {...params} label="Select Currency" size="small" sx={smallTextStyle} />}
          />
        </Paper>

        {/* City Dropdown */}
        <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" mb={2} fontWeight="bold">Select City</Typography>
          <Autocomplete
            options={cities}
            getOptionLabel={(option) => `${option.cityName} (${option.cityCode})`}
            value={cities.find((c) => c.cityCode === form.cityCode) || null}
            onChange={(e, selectedCity) => {
              setForm({
                ...form,
                city: selectedCity?.cityName || "",
                cityCode: selectedCity?.cityCode || "",
              });
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select City" size="small" sx={smallTextStyle} />
            )}
          />
        </Paper>

        {/* Rating */}
        <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" mb={2} fontWeight="bold">Rating</Typography>
          <TextField
            name="rating"
            value={form.rating}
            onChange={handleChange}
            select
            SelectProps={{ native: true }}
            fullWidth
            size="small"
            sx={smallTextStyle}
          >
            <option value="">Select Rating</option>
            {ratings.map((r) => (
              <option key={r} value={r}>{r} Star{r > 1 ? "s" : ""}</option>
            ))}
          </TextField>
        </Paper>

        {/* Floors & Room Counts */}
        <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" mb={2} fontWeight="bold">Floors & Room Counts</Typography>
          <TextField
            label="Number of Floors"
            type="number"
            value={form.floorCount || ""}
            onChange={(e) => {
              const floorCount = parseInt(e.target.value || 0);
              setForm((prev) => {
                const updatedRooms = [...(prev.rooms || [])];
                if (floorCount > updatedRooms.length) {
                  for (let i = updatedRooms.length; i < floorCount; i++) updatedRooms.push("");
                } else if (floorCount < updatedRooms.length) {
                  updatedRooms.splice(floorCount);
                }
                return { ...prev, floorCount, rooms: updatedRooms };
              });
            }}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
            inputProps={{ min: 1 }}
          />

          {form.rooms.length > 0 && (
            <Grid container spacing={2}>
              {form.rooms.map((count, idx) => (
                <Grid item xs={12} sm={4} key={idx}>
                  <TextField
                    label={`Floor ${idx + 1} Rooms Count`}
                    type="number"
                    value={count}
                    onChange={(e) => {
                      const updated = [...form.rooms];
                      updated[idx] = e.target.value;
                      setForm({ ...form, rooms: updated });
                    }}
                    fullWidth
                    size="small"
                    inputProps={{ min: 1 }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Paper>

        {/* Check-in / Check-out Time + 24 hours checkbox */}
  {/* Check-in / Check-out Time + 24 hours checkbox */}
<Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
  <Typography variant="h6" mb={2} fontWeight="bold">
    Check-in / Check-out Time
  </Typography>

  <Grid container spacing={2}>
    <Grid item xs={12} sm={6}>
      <TextField
        label="Check-in Time"
        type="time"
        name="checkInTime"
        value={form.checkInTime}
        onChange={handleChange}
        fullWidth
        size="small"
        InputLabelProps={{ shrink: true }}
        inputProps={{
          min: "00:00",
          max: "23:59",
          step: "900",
        }}
        disabled={form.is24Hour}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="Check-out Time"
        type="time"
        name="checkOutTime"
        value={form.checkOutTime}
        onChange={handleChange}
        fullWidth
        size="small"
        InputLabelProps={{ shrink: true }}
        inputProps={{
          min: "00:00",
          max: "23:59",
          step: "900",
        }}
        disabled={form.is24Hour}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        label="GST Number"
        name="gstNumber"
        value={form.gstNumber}
        onChange={handleChange}
        fullWidth
        size="small"
        sx={smallTextStyle}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        label="Food License Number"
        name="foodLicenseNumber"
        value={form.foodLicenseNumber}
        onChange={handleChange}
        fullWidth
        size="small"
        sx={smallTextStyle}
      />
    </Grid>

<Grid item xs={12} sm={4}>
  <TextField
    select
    label="24 Hour Hotel"
    name="is24Hour"
    value={form.is24Hour ? "true" : "false"}
    onChange={(e) =>
      setForm((prev) => ({
        ...prev,
        is24Hour: e.target.value === "true"
      }))
    }
    SelectProps={{ native: true }}
    fullWidth
    size="small"
  >
    <option value="false">No</option>
    <option value="true">Yes</option>
  </TextField>
</Grid>
  </Grid>
</Paper>

        {/* Amenities & Attractions */}
        <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" mb={2} fontWeight="bold">Amenities & Attractions</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography mb={1}>Amenities</Typography>
              {form.amenities.map((item, idx) => (
                <Box key={idx} display="flex" alignItems="center" mb={1}>
                  <TextField
                    value={item}
                    onChange={(e) => handleArrayChange("amenities", idx, e.target.value)}
                    fullWidth
                    size="small"
                    sx={smallTextStyle}
                  />
                  <IconButton color="primary" onClick={() => addArrayField("amenities")}>
                    <AddIcon />
                  </IconButton>
                  {form.amenities.length > 1 && (
                    <IconButton color="error" onClick={() => removeArrayField("amenities", idx)}>
                      <RemoveIcon />
                    </IconButton>
                  )}
                </Box>
              ))}
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography mb={1}>Attractions</Typography>
              {form.attractions.map((item, idx) => (
                <Box key={idx} display="flex" alignItems="center" mb={1}>
                  <TextField
                    value={item}
                    onChange={(e) => handleArrayChange("attractions", idx, e.target.value)}
                    fullWidth
                    size="small"
                    sx={smallTextStyle}
                  />
                  <IconButton color="primary" onClick={() => addArrayField("attractions")}>
                    <AddIcon />
                  </IconButton>
                  {form.attractions.length > 1 && (
                    <IconButton color="error" onClick={() => removeArrayField("attractions", idx)}>
                      <RemoveIcon />
                    </IconButton>
                  )}
                </Box>
              ))}
            </Grid>
          </Grid>
        </Paper>

        {/* Images */}
        <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" mb={2} fontWeight="bold">Upload Hotel Images</Typography>
          <Button variant="contained" component="label" startIcon={<PhotoCamera />} fullWidth>
            Upload Images
            <input hidden type="file" accept="image/*" multiple onChange={handleImageChange} />
          </Button>
          {form.images.length > 0 && (
            <Box sx={{ display: "flex", overflowX: "auto", gap: 2, py: 2 }}>
              {form.images.map((img, idx) => {
                const url = URL.createObjectURL(img.file);
                return (
                  <Box
                    key={idx}
                    sx={{
                      position: "relative",
                      minWidth: 120,
                      width: 120,
                      height: 120,
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={url}
                      alt={`Hotel ${idx + 1}`}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      onLoad={() => URL.revokeObjectURL(url)}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteImage(idx)}
                      sx={{ position: "absolute", top: 5, right: 5, bgcolor: "white" }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                );
              })}
            </Box>
          )}
        </Paper>

<Button
  variant="contained"
  color="primary"
  size="large"
  fullWidth
  sx={{ mt: 4, py: 2 }}
  onClick={handleSubmit}
>
  Add Hotel
</Button>
      </form>
    </Container>
  );
}